module.exports = __webpack_public_path__ + "static/media/patient-01.e9971c0b.svg";